import { scrollParentY } from './_scrollParent.js';
export const scrollTo = (el, position) => {
    const isSelector = typeof el === 'string';

    // Determine if the item is a selector or HTML element
    const panel = isSelector ? document.getElementById(el) : el;

    // Check if panel exists (DOM elements don't have length property)
    if (!panel) {
        console.warn('ScrollTo: Element not found', el);
        return;
    }

    const scroll = scrollParentY(panel);

    const moveIntoView = () => {
        if (position === 'center') {
            panel.scrollIntoView({ block: 'center' });
        } else {
            let offset = window.innerWidth < 640 ? 120 : 85;
            if (position > 0) {
                offset = position * 1;
            }
            panel.scrollIntoView(true);
            if (scroll) {
                scroll.scrollTop -= offset;
            } else {
                window.scrollBy(0, offset * -1);
            }
        }
    };

    moveIntoView();

    setTimeout(function () {
        // Find the target element more safely
        let target = null;

        if (panel.classList.contains('mvt-collapse')) {
            target = panel;
        } else if (panel.offsetParent !== null) {
            target = panel.querySelector('.mvt-collapse');
        } else {
            target = panel.closest('.mvt-collapse');
        }

        // Check if target exists and has Vue instance
        if (target && target.__vue__) {
            const vnode = target.__vue__;
            if (vnode.open && !vnode.active) {
                vnode.open();
                setTimeout(() => {
                    moveIntoView();
                }, 10);
            }
        }
    }, 100);
};
